import { useReferralQuest } from '@src/hooks/useQuests';
import { HStack, Skeleton, Text, VStack } from 'ui_2';
import parc_3d from '@assets/parc_3d.png';
import { BiChevronRight } from 'react-icons/bi';
import { Route as ReferralRoute } from '@src/routes/referral';
import { Link } from '@tanstack/react-router';
import { useDappState } from '@src/hooks/useDappState';
import { useViewTransition } from '@src/hooks/useViewTransition';
import { useEffect } from 'react';

export const ReferralQuestRow = () => {
  const { data, error, isLoading, fetchStatus } = useReferralQuest();
  const isActuallyLoading = isLoading && fetchStatus !== 'idle';
  const { isPuzzleWalletWebview } = useDappState();
  const { slideLeftFullPage } = useViewTransition();

  useEffect(() => {
    if (error) {
      console.error('Error in ReferralQuestRow', error?.message, error);
    }
  }, [error]);

  if (isActuallyLoading) {
    return <Skeleton className='h-[74px] w-full max-w-[500px]' />;
  } else if (!data) {
    return null;
  }

  return (
    <Link
      to={ReferralRoute.to}
      viewTransition={isPuzzleWalletWebview ? slideLeftFullPage : undefined}
      className='w-full'
    >
      <HStack className='w-full items-center gap-2 rounded-[10px] border border-gray-100 px-4 py-3'>
        <img src={parc_3d} width='36px' height={'37px'} />
        <VStack>
          <Text font='bold-sm'>{data.title}</Text>
          <Text font='sm'>{data.description}</Text>
        </VStack>
        <HStack className='flex-grow' />
        <BiChevronRight className='justify-end text-gray-400' size={24} />
      </HStack>
    </Link>
  );
};
